import barba from '@barba/core'
import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js'
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js'
import Botpoison from '@botpoison/browser'
import { ModuleRegistry, AllCommunityModule, createGrid } from 'ag-grid-community'
import { loadPageStyle, pageAssetPrefetch } from './load-assets.js'

ModuleRegistry.registerModules([AllCommunityModule]);

// barba
barba.use(pageAssetPrefetch)
barba.init({
  debug: false,
  transitions: [{
    name: 'global',
    beforeEnter({ next }) {
      void loadPageStyle(next.namespace)
      startQuizPopupTimer(next)
    },
    once({ next }) {
      addTopAnchors()
      addDirectionsLinks(document)
      setupTelMailToTracking(document)
      setupTouchMenu()
      setupTouchDropdowns()
      setupPromoBar()
      setupQuizDialog()
      initGoogleAnalytics()
      initMetaPixel()
      scheduleTawkTo()
      trackPageView()
      updateScrollbar()
      window.addEventListener('scroll', updateScrollbar, { passive: true })
      window.addEventListener('resize', updateScrollbar, { passive: true })
      if (next.namespace === 'faq') initFaqFiltering(next)
    },
    beforeLeave({ next }) {
      removeTopAnchors()
      document.documentElement.setAttribute('data-loading', '')
      if (window.__pendingHashScroll) {
        window.__leaveScrollY = window.scrollY
        const namespace = document.querySelector('[data-barba="container"]')?.dataset?.namespace
        if (
          window.__leaveScrollY > 0 ||
          ['quiz', 'gallery', 'inventory'].includes(namespace)
        ) {
          tuckHeaderForTransition()
          window.__headerTuckLocked = true
        }
      }
      void scrollbarThumb.offsetHeight
      scrollbarThumb.style.height = '0px'
      document.activeElement.blur()
    },
    enter({ next }) {
      preparePageTransition(next)
    },
    after() {
      trackPageView()
    },
    afterEnter({ next, current }) {
      setTimeout(() => { addTopAnchors() }, 0)
      return handlePageTransition(next, current)
    },
  }],
  views: [
    {
      namespace: 'home',
      beforeEnter({ next }) {
        initSliders(next)
        setupCloudflareStream(next)
        addDirectionsLinks(next.container)
      },
    },
    {
      namespace: 'meet-the-team',
      beforeEnter() {
      },
    },
    {
      namespace: 'our-story',
      beforeEnter() {
      },
    },
    {
      namespace: 'our-process',
      afterEnter({ next }) {
        initProcessProgress(next)
      },
      beforeLeave() {
        if (processProgressCleanup) processProgressCleanup()
      },
    },
    {
      namespace: 'blog',
      beforeEnter() {
      },
    },
    {
      namespace: 'blog-post',
      beforeEnter({ next }) {
        addDirectionsLinks(next.container)
        setupTelMailToTracking(next.container)
      },
    },
    {
      namespace: 'faq',
      beforeEnter({ next }) {
        initFaqFiltering(next)
        addDirectionsLinks(next.container)
        setupTelMailToTracking(next.container)
        if (window.ResizeObserver) {
          faqResizeObserver = new ResizeObserver(updateScrollbar)
          faqResizeObserver.observe(document.documentElement)
        }
      },
      afterLeave() {
        if (faqResizeObserver) {
          faqResizeObserver.disconnect()
          faqResizeObserver = null
        }
      }
    },
    {
      namespace: 'products',
      beforeEnter() {
      },
    },
    {
      namespace: 'product_roomvo',
      beforeEnter({ next }) {
        getRoomvoCatalog(next)
      },
    },
    {
      namespace: 'product_custom',
      beforeEnter() {
      },
    },
    {
      namespace: 'projects',
      beforeEnter({ next }) {
        if (window.__pendingProjectsProductView) {
          setProjectsProductView(next.container)
          window.__pendingProjectsProductView = null
        }
        const toggles = next.container.querySelectorAll('input[name="toggle"]')
        const handler = () => {
          requestAnimationFrame(() => {
            scrollbarThumb.style.transition = 'height var(--easing--norm)'
            updateScrollbar()
            scrollbarThumb.addEventListener('transitionend', () => {
              scrollbarThumb.style.transition = ''
            }, { once: true })
          })
        }
        toggles.forEach(t => t.addEventListener('change', handler))
        projectsToggleCleanup = () => {
          toggles.forEach(t => t.removeEventListener('change', handler))
          projectsToggleCleanup = null
        }
      },
      beforeLeave() {
        if (projectsToggleCleanup) {
          projectsToggleCleanup()
        }
      }
    },
    {
      namespace: 'gallery',
      beforeEnter({ next }) {
        initFancyapps(next)
      }
    },
    {
      namespace: 'testimonials',
      beforeEnter({ next }) {
        setupCloudflareStream(next)
      },
    },
    {
      namespace: 'reviews',
      beforeEnter() {
        getFeedspring()
      },
    },
    {
      namespace: 'inventory',
      beforeEnter({ next }) {
        initAgGrid(next)
      },
      beforeLeave() {
        inventoryLightboxDestroy?.()
        inventoryLightboxDestroy = null
      },
    },
    {
      namespace: 'request-an-estimate',
      beforeEnter({ next }) {
        initPhoneFormatter(next)
        initFormspark(next)
        setupTelMailToTracking(next.container)
      },
    },
    {
      namespace: 'quiz',
      beforeEnter({ next }) {
        initQuiz(next)
        initPhoneFormatter(next)
        initFormspark(next)
      },
    }
  ],
})


// tawk.to
const waitForPageLoad = () => new Promise(resolve => {
  if (document.readyState === 'complete') resolve()
  else window.addEventListener('load', resolve, { once: true })
})

const labelTawkIframe = iframe => {
  if (iframe.title || iframe.classList.contains('stream-player')) return
  if (iframe.closest('wrf-app')) return

  const src = iframe.getAttribute('src') || ''
  if (src.includes('cloudflarestream.com')) return

  iframe.title = (iframe.offsetWidth || parseInt(iframe.getAttribute('width'), 10) || 0) <= 80
    && (iframe.offsetHeight || parseInt(iframe.getAttribute('height'), 10) || 0) <= 80
    ? 'Open live chat'
    : 'Live chat conversation'
}

const labelTawkIframes = () => {
  document.querySelectorAll('iframe').forEach(labelTawkIframe)
}

const scheduleTawkTo = () => {
  void waitForPageLoad().then(() => { void initTawkTo() })
}

const initTawkTo = () => {
  window.Tawk_API = window.Tawk_API || {}
  const previousOnLoad = window.Tawk_API.onLoad
  window.Tawk_API.onLoad = function() {
    if (typeof previousOnLoad === 'function') previousOnLoad()
    labelTawkIframes()
  }

  return new Promise((resolve, reject) => {
    const scriptSrc = 'https://embed.tawk.to/6854445ec96da61913b70202/1iu4im492'
    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.async = true
    script.src = scriptSrc
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')
    script.onload = resolve
    script.onerror = reject

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  })
}


// google analytics & meta pixel
const initGoogleAnalytics = () => {
  return new Promise((r, error) => {
    const measurementId = 'G-399NF7K75G'
    const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    if (document.querySelector(`script[src="${scriptSrc}"]`)) { r(); return }
    const script = document.createElement('script')
    script.src = scriptSrc
    script.onload = () => {
      window.dataLayer = window.dataLayer || []
      function gtag() { dataLayer.push(arguments) }
      window.gtag = gtag
      gtag('js', new Date())
      gtag('config', `${measurementId}`, { send_page_view: false })
      r()
    }
    script.onerror = error
    document.head.appendChild(script)
  })
}

const initMetaPixel = () => {
  const pixelId = '2635350643382691'
  if (window.fbq) return Promise.resolve()

  return new Promise((resolve) => {
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js')
    fbq('init', pixelId)
    resolve()
  })
}

const metaStandardEvents = {
  form_submit: 'Lead',
  tel_click: 'Contact',
  mailto_click: 'Contact',
  directions_click: 'FindLocation'
}

const trackEvent = (eventName, params = {}) => {
  window.gtag?.('event', eventName, params)
  const metaEvent = metaStandardEvents[eventName]
  if (metaEvent) window.fbq?.('track', metaEvent, params)
  else window.fbq?.('trackCustom', eventName, params)
}

const trackPageView = () => {
  window.gtag?.('event', 'page_view', { page_path: location.pathname + location.search })
  window.fbq?.('track', 'PageView')
}

const setupTelMailToTracking = (scope = document) => {
  scope.querySelectorAll('a[href^="tel:"]').forEach(link => {
    link.addEventListener('click', () => {
      trackEvent('tel_click', { contact_method: 'phone' })
    })
  })

  scope.querySelectorAll('a[href^="mailto:"]').forEach(link => {
    link.addEventListener('click', () => {
      trackEvent('mailto_click', { contact_method: 'email' })
    })
  })
}


// formspark
const initFormspark = (next) => {
  next.container.querySelectorAll('form[action^="https://submit-form.com"]').forEach(form => {
    if (form.hasAttribute('data-formspark-bound')) return
    form.setAttribute('data-formspark-bound', '')

    form.addEventListener('submit', e => {
      e.preventDefault()
      const botpoison = new Botpoison({ publicKey: 'pk_72990c95-838a-4eea-bcdf-9fed629a8237' })
      const parent = form.parentElement
      const successMessage = parent.querySelector('.message--success')
      const errorMessage = parent.querySelector('.message--error')
      const submitBtn = form.querySelector('button[type="submit"]')

      const setupSubmitBtn = disabled => {
        submitBtn.querySelectorAll('span').forEach(span => {
          span.textContent = disabled ? submitBtn.getAttribute('data-wait') : 'Submit'
        })
        submitBtn.disabled = disabled
      }
      setupSubmitBtn(true)

      botpoison
        .challenge()
        .then(result => {
          const data = new URLSearchParams(new FormData(form))
          data.append('_botpoison', result.solution)

          return fetch(form.action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data.toString()
          })
        })
        .then(res => {
          if (!res.ok) throw new Error('Form submit failed')
          return res.json()
        })
        .then(() => {
          form.style.display = 'none'
          if (successMessage) successMessage.style.display = 'block'
          trackEvent('form_submit', { form_id: form.id })
        })
        .catch(() => {
          if (errorMessage) errorMessage.style.display = 'block'
        })
        .finally(() => {
          setupSubmitBtn(false)
        })
    })
  })
}


// fancyapps
const initFancyapps = (next) => {
  const carouselElement = next.container.querySelector('.f-carousel')

  const carousel = new Carousel(carouselElement, {
    transition: 'crossfade',
    Dots: false,
    Navigation: {
      classes: {
        button: 'btn--slider',
      },
      prevTpl: '<svg viewBox="0 0 8 14" class="icon--chev"><path fill="currentColor" d="M7.86 12.6L6.46 14L5.76 13.3L0 7.56V6.46L6.46 0L7.86 1.4L2.25 7L7.85 12.6H7.86Z"></path></svg>',
      nextTpl: '<svg viewBox="0 0 8 14" class="icon--chev"><path fill="currentColor" d="M0 1.4L1.4 0L2.1 0.7L7.86 6.44V7.54L1.4 14L0 12.6L5.61 7L0.00999975 1.4H0Z"></path></svg>',
    },
    on: {
      init: (instance) => {

        document.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            instance.slidePrev()
          } else if (e.key === 'ArrowRight') {
            instance.slideNext()
          }
        })
      }
    }
  }, { Thumbs })
}


// feedspring
const getFeedspring = () => {
  if (!window.feedspringWidget) {
    fetch('https://scripts.feedspring.com/google-reviews-attrs.js')
      .then((response) => response.text())
      .then((scriptContent) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.text = scriptContent
        document.head.appendChild(script)

        const initializationCheck = setInterval(() => {
          if (window.feedspringWidget) {
            window.feedspringWidget.initialize()
            clearInterval(initializationCheck)
          }
        }, 50)
      })
      .catch((error) => {
        console.error('Feedspring initialization failed:', error)
      })
  } else {
    window.feedspringWidget.initialize()
  }
}


// roomvo
const getRoomvoCatalog = (next) => {
  const filterParam = next.container.querySelector('[data-filter-param]').dataset.filterParam
  const currentUrl = new URL(window.location.href)
  const baseUrl = currentUrl.origin + currentUrl.pathname
  history.replaceState(null, '', baseUrl + filterParam)

  new Promise((resolve, reject) => {
    const scriptUrl = 'https://www.roomvo.com/static/scripts/b2b/common/assistant.js'
    const attributes = {
      id: 'roomvoAssistant',
      type: 'text/javascript',
      'data-locale': 'en-us',
      'data-position': 'bottom-right'
    }
    if (document.querySelector(`script[src="${scriptUrl}"]`) || document.querySelector(`#${attributes.id}`)) {
      resolve()
    } else {
      const script = document.createElement('script')
      script.src = scriptUrl
      Object.entries(attributes).forEach(([key, value]) => script.setAttribute(key, value))
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    }
  }).then(() =>
    new Promise((resolve, reject) => {
      const maxRetries = 50
      let retryCount = 0
      const intervalId = setInterval(() => {
        try {
          window._roomvo.whiteriverflooring.addProductCatalog()
          const catalogEl = next.container.querySelector('#roomvoCatalog')
          if (catalogEl.innerHTML.trim() !== "") {
            const currentUrl = new URL(window.location.href)
            const baseUrl = currentUrl.origin + currentUrl.pathname
            if (currentUrl.search === filterParam) {
              history.replaceState(null, '', baseUrl)
            }
            clearInterval(intervalId)
            resolve()
          }
        } catch (error) {
          retryCount++
          if (retryCount >= maxRetries) {
            clearInterval(intervalId)
            reject(new Error('Roomvo catalog did not load within the expected time.'))
          }
        }
      }, 100)
    })
  )
}


// cloudflare
const setupCloudflareStream = (next) => {
  const playerInstances = []
  const players = next.container.querySelectorAll('.stream-player')

  players.forEach(playerEl => {
    const player = Stream(playerEl)
    player.controls = false
    playerEl.player = player
    playerInstances.push(player)

    playerEl.closest('.btn--media').addEventListener('click', () => {
      playerEl.parentElement.nextElementSibling.style.opacity = '0'
      playerEl.style.pointerEvents = 'auto'
      player.controls = true
      player.play()
    })
  })

  if (next.namespace === 'home') {
    next.container.querySelectorAll('.testimonials--home button[data-slider]').forEach(btn => {
      btn.addEventListener('click', () => {
        playerInstances.forEach(player => {
          player.pause()
        })
      })
    })
  }

  if (next.namespace === 'testimonials') {
    next.container.querySelectorAll('[data-play-btn]').forEach(btn => {
      btn.isPlaying = false
      btn.addEventListener('click', () => {
        const playerEl = btn.closest('.block-item__content').querySelector('.stream-player')
        playerEl.parentElement.nextElementSibling.style.opacity = '0'
        playerEl.style.pointerEvents = 'auto'
        playerEl.player.controls = true

        if (btn.isPlaying) {
          playerEl.player.pause()
          btn.querySelectorAll('span').forEach(span => {
            span.textContent = 'Play Video Testimonial'
          })
          btn.isPlaying = false
        } else {
          playerEl.player.play()
          btn.querySelectorAll('span').forEach(span => {
            span.textContent = 'Pause Video Testimonial'
          })
          btn.isPlaying = true
        }
      })
    })
  }
}


// inventory lightbox
const lightboxTransitionActive =
  'left .42s var(--bezier-alt), top .42s var(--bezier-alt), width .42s var(--bezier-alt), height .42s var(--bezier-alt), border-radius .42s var(--bezier-alt), object-fit .42s var(--bezier-alt)'

const lightboxTargetCenter = img => {
  const vw = innerWidth
  const vh = innerHeight
  const maxW = vw * .92
  const maxH = vh * .92
  const nw = img.naturalWidth
  const nh = img.naturalHeight
  let w
  let h
  if (nw <= 0 || nh <= 0) {
    w = maxW * .6
    h = maxH * .6
  } else {
    const scale = Math.min(maxW / nw, maxH / nh, 1)
    w = nw * scale
    h = nh * scale
  }
  return { left: (vw - w) / 2, top: (vh - h) / 2, width: w, height: h }
}

const lightboxFlyTo = (img, rect, fly = {}) => {
  const { objectFit, transition, borderRadius } = {
    objectFit: 'cover',
    transition: 'none',
    borderRadius: '12px',
    ...fly
  }
  const s = img.style
  const { left, top, width, height } = rect
  s.position = 'fixed'
  s.left = `${left}px`
  s.top = `${top}px`
  s.width = `${width}px`
  s.height = `${height}px`
  s.maxWidth = 'none'
  s.maxHeight = 'none'
  s.margin = '0'
  s.objectFit = objectFit
  s.transition = transition
  s.borderRadius = borderRadius
}

const lightboxRefit = (img, session, homeRect) => {
  if (session.closing) {
    lightboxFlyTo(img, homeRect, {
      objectFit: 'cover',
      transition: 'none',
      borderRadius: session.startRadius
    })
  } else {
    lightboxFlyTo(img, lightboxTargetCenter(img), {
      objectFit: 'contain',
      transition: 'none',
      borderRadius: session.endRadius
    })
  }
}

const lightboxTransitionProps = new Set([
  'width',
  'height',
  'left',
  'top',
  'border-radius',
  'object-fit'
])

const lightboxWaitTransition = el =>
  new Promise(resolve => {
    const onEnd = e => {
      if (e.target !== el || !lightboxTransitionProps.has(e.propertyName)) return
      el.removeEventListener('transitionend', onEnd)
      resolve()
    }
    el.addEventListener('transitionend', onEnd)
  })

const lightboxGetThumbRect = img => {
  const slot = img.closest('.ag-img')
  if (!slot) return img.getBoundingClientRect()
  const { left, top } = slot.getBoundingClientRect()
  return { left, top, width: 88, height: 88 }
}

const lightboxDetachImg = (img, onCloseClick) => {
  if (onCloseClick) img.removeEventListener('click', onCloseClick)
  img.hidePopover()
  img.removeAttribute('style')
}

const lightboxClose = ({ getSession, setSession }) => {
  const s = getSession()
  if (!s || s.closing) return Promise.resolve()

  s.closing = true
  const { img } = s
  lightboxFlyTo(img, lightboxGetThumbRect(img), {
    objectFit: 'cover',
    transition: lightboxTransitionActive,
    borderRadius: s.startRadius
  })

  return lightboxWaitTransition(img).then(() => {
    lightboxDetachImg(s.img, s.onCloseClick)
    if (getSession() === s) setSession(null)
  })
}

const lightboxOpen = async (img, { setSession, getSession, nextZ }) => {
  const s = getSession()
  if (s?.img === img && img.matches(':popover-open') && !s.closing) return

  void lightboxClose({ getSession, setSession })

  await new Promise(r => requestAnimationFrame(r))

  const homeRect = lightboxGetThumbRect(img)
  const startRadius = getComputedStyle(img).borderRadius || '12px'
  const endRadius = startRadius

  const onCloseClick = ev => {
    if (ev.button !== 0) return
    lightboxClose({ getSession, setSession })
  }

  setSession({
    img,
    homeRect,
    onCloseClick,
    startRadius,
    endRadius,
    closing: false
  })

  img.addEventListener('click', onCloseClick)

  lightboxFlyTo(img, homeRect, {
    objectFit: 'cover',
    transition: 'none',
    borderRadius: startRadius
  })

  img.showPopover()
  img.style.zIndex = nextZ()

  await new Promise(r => requestAnimationFrame(r))

  lightboxFlyTo(img, lightboxTargetCenter(img), {
    objectFit: 'contain',
    transition: lightboxTransitionActive,
    borderRadius: endRadius
  })
}

const lightboxRafSchedule = fn => {
  let id = null
  return () => {
    if (id != null) cancelAnimationFrame(id)
    id = requestAnimationFrame(() => {
      id = null
      fn()
    })
  }
}

const createInventoryLightbox = root => {
  let lightboxState = null
  let stackZ = 0
  const ac = new AbortController()
  const { signal } = ac

  const getSession = () => lightboxState
  const setSession = v => {
    lightboxState = v
  }

  const closeCtx = {
    getSession,
    setSession,
    nextZ: () => String(++stackZ)
  }
  const close = () => lightboxClose(closeCtx)

  document.addEventListener(
    'click',
    e => {
      const session = getSession()
      if (!session) return
      if (session.img.contains(e.target)) return
      if (e.target.closest('img[data-zoomable]')) return
      close()
    },
    { capture: true, signal }
  )

  document.addEventListener(
    'keydown',
    e => {
      if (e.key !== 'Escape') return
      if (!getSession()) return
      e.preventDefault()
      close()
    },
    { capture: true, signal }
  )

  window.addEventListener(
    'resize',
    lightboxRafSchedule(() => {
      const s = getSession()
      s && lightboxRefit(s.img, s, s.closing ? lightboxGetThumbRect(s.img) : s.homeRect)
    }),
    { passive: true, signal }
  )

  const bindImage = img => {
    img.popover = 'manual'

    img.addEventListener(
      'click',
      async e => {
        if (e.button !== 0) return
        if (getSession()?.img === img && img.matches(':popover-open')) {
          close()
          return
        }
        await lightboxOpen(img, closeCtx)
      },
      { signal }
    )

    img.addEventListener(
      'keydown',
      async e => {
        if (e.key !== 'Enter' && e.key !== ' ') return
        e.preventDefault()
        if (getSession()?.img === img && img.matches(':popover-open')) {
          close()
          return
        }
        await lightboxOpen(img, closeCtx)
      },
      { signal }
    )

    img.addEventListener(
      'toggle',
      e => {
        if (e.newState !== 'closed' || getSession()?.img !== e.target) return
        const snap = getSession()
        setSession(null)
        snap && lightboxDetachImg(snap.img, snap.onCloseClick)
      },
      { signal }
    )
  }

  const attach = () => {
    root.querySelectorAll('img[data-zoomable]:not([data-lb-bound])').forEach(img => {
      img.setAttribute('data-lb-bound', '')
      bindImage(img)
    })
  }

  const destroy = () => {
    close()
    ac.abort()
  }

  return { attach, destroy, close, open: img => lightboxOpen(img, closeCtx) }
}


// ag grid
let gridApi
let inventoryLightboxDestroy = null

const initAgGrid = (next) => {
  fetch('/inventory/data.json')
    .then(res => res.json())
    .then(inventoryData => {
      window.INVENTORY_DATA = inventoryData
      const filteredData = inventoryData.filter(item => Number(item.amount_available) > 0);

      const gridOptions = {
        rowData: filteredData,
        columnDefs: [
          {
            field: 'product_type',
            headerName: 'Product Type',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            sortable: true,
            sortingOrder: ['asc', 'desc', null],
            width: 280,
            cellRenderer: (params) => {
              const imgUrl = params.data?.image_url
              const name = params.value || ''
              return `
                <div class="ag-img">
                  ${imgUrl ? `<img data-zoomable tabindex="0" role="button" src="${imgUrl}" alt="${name}"/>` : ''}
                  <span>${name}</span>
                </div>
              `
            }
          },
          {
            field: 'manufacturer',
            headerName: 'Manufacturer',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 230
          },
          {
            field: 'style',
            headerName: 'Style',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 230
          },
          {
            field: 'color',
            headerName: 'Color',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 160
          },
          {
            field: 'product',
            headerName: 'Product',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 180
          },
          {
            field: 'amount_available',
            headerName: 'Amount Available',
            sortable: true,
            sort: 'desc',
            width: 183
          },
          {
            field: 'price',
            headerName: 'Price',
            sortable: true,
            sortingOrder: ['asc', 'desc', null],
            filter: 'agNumberColumnFilter',
            filterParams: {
              filterOptions: ['inRange', 'greaterThan', 'lessThan'],
              defaultOption: 'inRange',
              allowedCharPattern: '\\d\\,\\.',
              numberParser: text => {
                return text == null ? null : parseFloat(text.replace(',', '.'));
              },
              numberFormatter: value => {
                return value == null ? null : value.toString().replace('.', ',');
              }
            },
            width: 160,
            valueFormatter: params => {
              const price = params.value != null ? params.value.toFixed(2) : '';
              const uom = params.data?.uom ?? '';
              const separator = uom === 'Each' ? ' ' : '/';
              return `$${price}${uom ? separator + uom : ''}`;
            }
          },
        ],
        defaultColDef: {
          editable: false,
          sortable: false,
          resizable: true,
          sortingOrder: ['desc', 'asc', null],
        },
        rowHeight: 110,
        onGridReady(event) {
          window.inventoryGridApi = event.api;
          initProductTypeFilter(event.api);
        },
      }

      gridApi = createGrid(next.container.querySelector('.ag-grid'), gridOptions)

      inventoryLightboxDestroy?.()
      const lightbox = createInventoryLightbox(next.container)

      inventoryLightboxDestroy = lightbox.destroy

      const attachZoom = () => lightbox.attach()

      gridApi.addEventListener('firstDataRendered', attachZoom)
      gridApi.addEventListener('bodyScrollEnd', attachZoom)
      gridApi.addEventListener('filterChanged', attachZoom)
      gridApi.addEventListener('sortChanged', attachZoom)

      gridApi.addEventListener('cellKeyDown', e => {
        if (e.column.getColId() !== 'product_type') return
        if (e.event.key !== 'Enter' && e.event.key !== ' ') return

        const img = e.event.target.querySelector('img[data-zoomable]')
        if (!img) return

        e.event.preventDefault()
        if (img.matches(':popover-open')) {
          lightbox.close()
          return
        }
        void lightbox.open(img)
      })

      next.container.querySelector('.input--search').addEventListener('input', (e) => {
        gridApi.setGridOption('quickFilterText', e.target.value)
      })

      const scrollWrap = next.container.querySelector('.ag-grid__filters-scroll')

      const leftBtn = next.container.querySelector('[data-ag-btn-prev]')
      const rightBtn = next.container.querySelector('[data-ag-btn-next]')

      const updateScrollButtons = () => {
        const maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth - 68

        leftBtn.classList.toggle('is-hidden', scrollWrap.scrollLeft <= 0)
        rightBtn.classList.toggle('is-hidden', scrollWrap.scrollLeft >= maxScroll - 1)
      }

      updateScrollButtons()
      scrollWrap.addEventListener('scroll', updateScrollButtons)

      leftBtn.addEventListener('click', () => {
        scrollWrap.scrollBy({ left: -160, behavior: 'smooth' })
        setTimeout(updateScrollButtons, 200)
      })

      rightBtn.addEventListener('click', () => {
        scrollWrap.scrollBy({ left: 160, behavior: 'smooth' })
        setTimeout(updateScrollButtons, 200)
      })
    })
}

const initProductTypeFilter = (api) => {
  document
    .querySelectorAll('input[name="product-type"]')
    .forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        const val = radio.value;

        if (val === 'all') {
          api.setFilterModel(null);
        } else {
          api.setFilterModel({
            product_type: { type: 'equals', filter: val }
          });
        }

        api.onFilterChanged();
      });
    });
}


// scrollbar
const scrollbarThumb = document.querySelector('.scrollbar__thumb')
const root = document.documentElement
let faqResizeObserver = null
let processProgressCleanup = null
let projectsToggleCleanup = null

const updateScrollbar = () => {
  if (root.hasAttribute('data-loading')) return
  const scrollableHeight = root.scrollHeight - root.clientHeight
  const scrollPercent = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0
  scrollbarThumb.style.height = `${scrollPercent * 72}px`
}


// page transition
const preparePageTransition = (next) => {
  next.container.style.opacity = '0'
  void next.container.offsetHeight
}

const handlePageTransition = (next, current) => {
  return loadPageStyle(next.namespace).then(() => new Promise((resolve) => {
    const header = document.querySelector('.header')
    const headerBrand = document.querySelector('.header__brand')
    const headerLogo = headerBrand.querySelector('.link--logo')
    const brandHeight =
      headerBrand.getBoundingClientRect().height +
      parseFloat(getComputedStyle(headerBrand).marginBottom)
    const anchor = window.__pendingHashScroll

    if (anchor) {
      history.pushState(null, '', `/projects${anchor}`)
    }

    const leaveScrollY = anchor ? (window.__leaveScrollY ?? window.scrollY) : window.scrollY
    if (anchor) window.__leaveScrollY = null
    const progress = Math.min((leaveScrollY / brandHeight) * 100, 100)
    const headerTuckLocked = anchor && window.__headerTuckLocked

    if (headerTuckLocked) {
      window.__headerTuckLocked = null
      animateHeaderExtend(leaveScrollY)
    } else if (!['quiz', 'gallery', 'inventory'].includes(next.namespace)) {
      positionHeader({
        header,
        brandHeight,
        headerLogo,
        progress,
        currentNamespace: current.namespace,
      })
    } else {
      const offset = brandHeight - calcHeaderOffset(brandHeight, progress)
      header.style.transition = 'transform var(--easing--norm)'
      header.style.transform = `translateY(-${offset}px)`
      headerLogo.style.transition = 'opacity var(--easing--norm)'
      headerLogo.style.opacity = 0
      void header.offsetHeight
    }

    next.container.style.position = 'fixed'
    next.container.style.opacity = '0'
    void next.container.offsetHeight
    next.container.style.opacity = '1'

    let finished = false

    const finish = () => {
      if (finished) return
      finished = true
      clearTimeout(fallback)
      next.container.removeEventListener('transitionend', onTransitionEnd)

      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'instant' })

        next.container.removeAttribute('style')
        header.removeAttribute('style')
        headerLogo.removeAttribute('style')
        document.documentElement.removeAttribute('data-loading')
        updateScrollbar()
        resolve()

        if (anchor) {
          requestAnimationFrame(() => {
            scrollToProjectAnchor(anchor, document, 'smooth')
            window.__pendingHashScroll = null
          })
        }
      })
    }

    const onTransitionEnd = (event) => {
      if (event.target !== next.container || event.propertyName !== 'opacity') return
      finish()
    }

    next.container.addEventListener('transitionend', onTransitionEnd)
    const fallback = setTimeout(finish, 650)
  }))
}


// header
const calcHeaderOffset = (brandHeight, progress) => {
  return (brandHeight * progress) / 100
}

const tuckHeaderForTransition = () => {
  const header = document.querySelector('.header')
  const headerLogo = document.querySelector('.header__brand .link--logo')

  header.style.transition = 'none'
  header.style.transform = 'translateY(calc(-1 * var(--header--brand) + var(--spacing--200)))'
  headerLogo.style.transition = 'none'
  headerLogo.style.opacity = '1'
  headerLogo.style.transform = ''
  void header.offsetHeight
}

const animateHeaderExtend = (leaveScrollY = 0) => {
  const header = document.querySelector('.header')
  const headerLogo = document.querySelector('.header__brand .link--logo')
  const headerBrand = document.querySelector('.header__brand')

  const brandHeight =
    headerBrand.getBoundingClientRect().height +
    parseFloat(getComputedStyle(headerBrand).marginBottom)
  const progress = Math.min((leaveScrollY / brandHeight) * 100, 100)
  const endOffset = calcHeaderOffset(brandHeight, progress)

  requestAnimationFrame(() => {
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = endOffset > 0 ? `translateY(${endOffset}px)` : ''
    headerLogo.style.transition = 'transform var(--easing--norm), opacity var(--easing--norm)'
    headerLogo.style.transform = progress >= 100 ? 'translateY(var(--spacing--200))' : ''
    headerLogo.style.opacity = '1'
  })
}

const positionHeader = ({
  header,
  brandHeight,
  headerLogo,
  progress,
  currentNamespace,
}) => {

  if (progress > 0) {
    const offset = calcHeaderOffset(brandHeight, progress)
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = `translateY(${offset}px)`
    void header.offsetHeight
  }

  if (progress >= 100) {
    headerLogo.style.transform = 'translateY(var(--spacing--200))'
    void headerLogo.offsetHeight
  }

  if (['quiz', 'gallery', 'inventory'].includes(currentNamespace)) {
    header.style.transition = 'none'
    header.style.transform = `translateY(calc(-1 * var(--header--brand) + var(--spacing--200)))`
    void header.offsetHeight
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = ''
    headerLogo.style.opacity = 1
  }
}

const scrollToProjectAnchor = (anchor, container = document, behavior = 'instant') => {
  const target = container.querySelector(anchor)
  const top = target.getBoundingClientRect().top + window.scrollY
  window.scrollTo({ top, behavior })
}

const setupTouchMenu = () => {
  const header = document.querySelector('.header')
  const headerBrand = header.querySelector('.header__brand')
  const menuButton = header.querySelector('.btn--menu')
  const headerLogo = headerBrand.querySelector('.link--logo')
  let brandHeight =
    headerBrand.getBoundingClientRect().height +
    parseFloat(getComputedStyle(headerBrand).marginBottom)
  let progress = Math.min((window.scrollY / brandHeight) * 100, 100)
  let resizeTimeout

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 992 && (header.hasAttribute('open'))) {
        header.removeAttribute('open')
        header.style.transform = ''
        headerLogo.removeAttribute('style')
        document.documentElement.removeAttribute('data-noscroll')
      } else {
        brandHeight =
          headerBrand.getBoundingClientRect().height +
          parseFloat(getComputedStyle(headerBrand).marginBottom)
        progress = Math.min((window.scrollY / brandHeight) * 100, 100)
      }
    }, 300)
  })

  menuButton.addEventListener('click', () => {
    header.toggleAttribute('open')
    progress = Math.min((window.scrollY / brandHeight) * 100, 100)

    if (header.hasAttribute('open')) {
      positionHeader({
        header,
        brandHeight,
        headerLogo,
        progress,
        currentNamespace: document.querySelector('[data-barba="container"]').dataset.namespace
      })

      document.documentElement.setAttribute('data-noscroll', '')
    } else {
      header.style.transition = 'transform var(--easing--norm)'
      header.style.transform = ''
      document.documentElement.removeAttribute('data-noscroll')

      if (progress >= 100) {
        headerLogo.style.transition = 'transform var(--easing--norm)'
        headerLogo.style.transform = 'translateY(calc(var(--spacing--200) - .625rem))'
        headerLogo.addEventListener('transitionend', () => {
          headerLogo.style = ''
        })
      }
    }
  })

  header.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 991 && header.hasAttribute('open')) {
        closeTouchMenuComplete()
      }
    })
  })
}

const closeTouchMenuPartial = () => {
  const header = document.querySelector('.header')
  const headerBrand = header.querySelector('.header__brand')
  const headerLogo = headerBrand.querySelector('.link--logo')
  const brandHeight =
    headerBrand.getBoundingClientRect().height +
    parseFloat(getComputedStyle(headerBrand).marginBottom)
  const progress = Math.min((window.scrollY / brandHeight) * 100, 100)

  header.removeAttribute('open')

  if (progress >= 100) {
    headerLogo.style.transition = 'transform var(--easing--norm)'
    headerLogo.style.transform = 'translateY(calc(var(--spacing--200) - .625rem))'
    headerLogo.addEventListener('transitionend', () => {
      headerLogo.style = ''
    }, { once: true })
  }
}

const closeTouchMenuComplete = () => {
  if (window.innerWidth <= 991) {
    closeTouchMenuPartial()
    const header = document.querySelector('.header')
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = ''
    document.documentElement.removeAttribute('data-noscroll')
  }
}

const setupTouchDropdowns = () => {
  document.querySelectorAll('.btn--dropdown').forEach(btn => {
    btn.addEventListener('click', () => {
      const dropdown = btn.nextElementSibling

      document.querySelectorAll('.btn--dropdown + *').forEach(el => {
        el.style.height = el === dropdown && !el.style.height ? el.scrollHeight + 'px' : ''
      })
    })
  })
}


// anchor links
const addTopAnchors = () => {
  const currentPath = window.location.pathname.replace(/\/$/, '')

  document.querySelectorAll('.header, footer').forEach(scope => {
    scope.querySelectorAll('a').forEach(btn => {
      const btnHref = btn.getAttribute('href')
      const btnUrl = new URL(btnHref, window.location.href)
      const btnPath = btnUrl.pathname.replace(/\/$/, '')
      if (
        btnUrl.origin === window.location.origin &&
        btnPath === currentPath &&
        !btnUrl.hash
      ) {
        if (!btn.hasAttribute('data-href')) {
          btn.setAttribute('data-href', btnHref)
        }
        btn.setAttribute('href', '#top')
      }
    })
  })
}

const removeTopAnchors = () => {
  document.querySelectorAll('.header, footer').forEach(scope => {
    scope.querySelectorAll('a[href="#top"]').forEach(btn => {
      btn.setAttribute('href', btn.getAttribute('data-href'))
      btn.removeAttribute('data-href')
    })
  })
}

const smoothAnchorScroll = (event) => {
  const link = event.target.closest('a[href]')
  if (!link) return

  const href = link.getAttribute('href')
  if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return

  const currentPath = window.location.pathname.replace(/\/$/, '')

  if (href === '#top') {
    event.preventDefault()
    event.stopPropagation()
    window.scrollTo({ top: 0, behavior: 'smooth' })
    history.replaceState(null, '', link.getAttribute('data-href'))
    closeTouchMenuComplete()
    return
  }

  const url = new URL(href, window.location.href)
  if (url.origin !== window.location.origin || !url.hash || url.hash === '#top') return

  const linkPath = url.pathname.replace(/\/$/, '')
  const samePage = linkPath === currentPath
  if (!samePage && linkPath !== '/projects') return

  event.preventDefault()
  event.stopPropagation()

  if (samePage) {
    if (currentPath === '/projects') {
      setProjectsProductView(document.querySelector('[data-barba-namespace="projects"]'))
    }
    scrollToProjectAnchor(url.hash, document, 'smooth')
    history.replaceState(null, '', url.pathname + url.hash)
  } else {
    window.__pendingProjectsProductView = true
    window.__pendingHashScroll = url.hash
    barba.go('/projects')
  }

  closeTouchMenuComplete()
}

document.querySelectorAll('.header, footer').forEach(el => {
  el.addEventListener('click', smoothAnchorScroll, true)
})


const setProjectsProductView = (container) => {
  const trigger = container.querySelector('[data-toggle="trigger"]')
  if (!trigger?.checked) return false
  const productRadio = container.querySelector('input[name="toggle"]:not([data-toggle="trigger"])')
  productRadio.checked = true
  productRadio.dispatchEvent(new Event('change', { bubbles: true }))
  return true
}


// directions links
const addDirectionsLinks = (scope = document) => {
  const isAppleDevice = () => /Mac|iPad|iPhone|iPod/.test(navigator.userAgent)
  const appleMapsURL = 'https://maps.apple.com/?address=800%20S%20Main%20St,%20Searcy,%20AR%20%2072143,%20United%20States&auid=7131026317242709025&ll=35.241869,-91.735784&lsp=9902&q=White%20River%20Flooring%20Inc&t=m'
  const googleMapsURL = 'https://maps.app.goo.gl/kzHLsURgSZSL569H6'

  scope.querySelectorAll('a[href="#get-directions"]').forEach(link => {
    link.setAttribute('href', isAppleDevice() ? appleMapsURL : googleMapsURL)
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
    link.addEventListener('click', () => {
      trackEvent('directions_click')
    })
  })
}


// sliders
const initSliders = (next) => {
  next.container.querySelectorAll('[data-slider="container"]').forEach(slider => {
    const slides = Array.from(slider.querySelector('[data-slider="list"]').children)
    const pgnBtns = Array.from(slider.querySelectorAll('.btn--pgn'))
    const prev = slider.querySelector('[data-slider="prev"]')
    const next = slider.querySelector('[data-slider="next"]')

    let current = slides.findIndex(slide => slide.getAttribute('data-slider') === 'active')
    current = current === -1 ? 0 : current

    const update = newIndex => {
      current = (newIndex + slides.length) % slides.length

      slides.forEach((slide, index) => {
        const isActive = index === current
        slide.setAttribute('data-slider', isActive ? 'active' : '')
        if (isActive) slide.removeAttribute('inert')
        else slide.setAttribute('inert', '')
      })
      pgnBtns.forEach((btn, index) => {
        btn.setAttribute('data-slider', index === current ? 'index' : '')
        btn.setAttribute('tabindex', index === current ? '-1' : '0')
      })
    }

    prev.addEventListener('click', () => update(current - 1))
    next.addEventListener('click', () => update(current + 1))
    pgnBtns.forEach((btn, index) =>
      btn.addEventListener('click', () => update(index))
    )

    update(current)
  })
}


// our process
const initProcessProgress = (next) => {
  if (processProgressCleanup) processProgressCleanup()

  const track = next.container.querySelector('.process__progress')
  const fill = next.container.querySelector('.pgn--process')
  if (!track || !fill) return

  let ticking = false

  const update = () => {
    ticking = false
    const { top, height } = track.getBoundingClientRect()
    const progress = height > 0
      ? Math.min(Math.max((window.innerHeight * .5 - top) / height, 0), 1)
      : 0

    fill.style.transform = `scaleY(${progress})`
  }

  const onScroll = () => {
    if (ticking) return
    ticking = true
    requestAnimationFrame(update)
  }

  update()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })

  processProgressCleanup = () => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
    processProgressCleanup = null
  }
}


// faq
const faqInitedContainers = new WeakSet()

const initFaqAccordion = (scope) => {
  const faqDetails = scope.querySelectorAll('.faq .btn--faq-wrap')

  const closeOtherFaqDetails = (current) => {
    faqDetails.forEach(details => {
      if (details !== current && details.open && !details.classList.contains('is-closing')) {
        details.classList.add('is-closing')
      }
    })
  }

  const readFaqContentHeight = (content, style, prev, cb) => {
    const height = content.offsetHeight
    Object.assign(style, prev)
    if (cb) cb(height)
  }

  const getFaqContentHeight = (details, cb) => {
    const content = details.querySelector('.faq__answer')
    const style = content.style
    const prev = {
      height: style.height,
      position: style.position,
      visibility: style.visibility,
      overflow: style.overflow,
    }

    Object.assign(style, {
      position: 'absolute',
      visibility: 'hidden',
      height: 'auto',
      overflow: 'visible',
    })

    requestAnimationFrame(() => {
      requestAnimationFrame(() => readFaqContentHeight(content, style, prev, cb))
    })
  }

  const setFaqDetailsHeight = (details) => {
    if (!details.open || details.classList.contains('is-closing')) return
    getFaqContentHeight(details, height => {
      details.style.setProperty('--content-height', `${height}px`)
    })
  }

  const measureAndOpenFaq = (details) => {
    const content = details.querySelector('.faq__answer')

    content.style.height = '0'
    details.open = true

    requestAnimationFrame(() => {
      getFaqContentHeight(details, (height) => {
        details.style.setProperty('--content-height', `${height}px`)
        requestAnimationFrame(() => { content.style.height = '' })
      })
    })
  }

  faqDetails.forEach(details => {
    const toggle = details.querySelector('.btn--faq')
    const content = details.querySelector('.faq__answer')

    toggle.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return
      details.dataset.faqWasOpen = details.open ? '1' : '0'
    }, true)

    toggle.addEventListener('click', (event) => {
      event.preventDefault()

      const trackedOpen = details.dataset.faqWasOpen
      const wasOpen = trackedOpen != null ? trackedOpen === '1' : details.open
      details.removeAttribute('data-faq-was-open')

      if (details.classList.contains('is-closing')) {
        details.classList.remove('is-closing')
        return
      }

      if (wasOpen) {
        if (!details.open) details.open = true
        details.classList.add('is-closing')
      } else {
        if (details.open) details.open = false
        closeOtherFaqDetails(details)
        measureAndOpenFaq(details)
      }
    }, true)

    content.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'height' && details.classList.contains('is-closing')) {
        details.open = false
        details.classList.remove('is-closing')
      }
    })

    details.addEventListener('toggle', () => {
      if (details.open) closeOtherFaqDetails(details)
    })
  })

  window.addEventListener('resize', () => faqDetails.forEach(setFaqDetailsHeight))
}

const initFaqFiltering = (next) => {
  if (faqInitedContainers.has(next.container)) return
  faqInitedContainers.add(next.container)

  initFaqAccordion(next.container)

  const faqNav = next.container.querySelector('.faq__nav')
  const faqFiltersList = faqNav.querySelector('.nav__filters-list')
  const faqRadios = faqNav.querySelectorAll('input[name="filter"]')
  const faqItems = next.container.querySelectorAll('.faq__list--item')

  const updateNavBtnBg = radio => {
    requestAnimationFrame(() => {
      const { width, height, top, left } = faqNav.querySelector(`label[for="${radio.id}"]`).getBoundingClientRect()
      const navRect = faqNav.getBoundingClientRect()
      faqFiltersList.style.setProperty('--btn-width', `${width}px`)
      faqFiltersList.style.setProperty('--btn-height', `${height}px`)
      faqFiltersList.style.setProperty('--btn-top', `${top - navRect.top}px`)
      faqFiltersList.style.setProperty('--btn-left', `${left - navRect.left}px`)
    })
  }

  const updateFaqItems = radio => {
    faqItems.forEach(item => {
      const match = item.getAttribute('data-match').includes(radio.id)
      item.toggleAttribute('data-active', match)
      item.toggleAttribute('inert', !match)
    })
    scrollbarThumb.style.transition = 'height var(--easing--norm)'
    updateScrollbar()
    scrollbarThumb.addEventListener('transitionend', () => {
      scrollbarThumb.style.transition = ''
    }, { once: true })
  }

  const handleRadioChange = radio => {
    updateNavBtnBg(radio)
  }

  const params = new URLSearchParams(window.location.search)
  const filterValue = params.get('view') || 'all'
  const targetRadio = Array.from(faqRadios).find(r => r.id === filterValue) || faqRadios[0]
  targetRadio.checked = true
  handleRadioChange(targetRadio)
  updateFaqItems(targetRadio)

  faqRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      handleRadioChange(radio)
      if (window.innerWidth > 479) {
        const faqAnchor = next.container.querySelector('.anchor--faq')
        const anchorTop = faqAnchor.getBoundingClientRect().top
        if (Math.abs(anchorTop) < 2) {
          updateFaqItems(radio)
        } else {
          faqAnchor.scrollIntoView({ behavior: 'smooth' })
          document.addEventListener('scrollend', () => {
            updateFaqItems(radio)
          }, { once: true })
        }
      } else {
        updateFaqItems(radio)
      }
      const newParams = new URLSearchParams(window.location.search)
      newParams.set('view', radio.id)
      window.history.pushState({}, '', `${window.location.pathname}?${newParams.toString()}`)
    })
  })

  const faqFiltersObserver = new ResizeObserver(() => {
    const checked = Array.from(faqRadios).find(r => r.checked)
    handleRadioChange(checked)
  })
  faqFiltersObserver.observe(document.documentElement)
}


// phone input formatter
const initPhoneFormatter = (next) => {
  const formatPhone = (value) => {
    let phone = value.replace(/[^\d()\-x]/g, '')
    const numbersOnly = phone.replace(/[^\d]/g, '')
    const maxLength = 10

    if (numbersOnly.length === 0) return ''
    if (numbersOnly.length <= 3) return numbersOnly
    if (numbersOnly.length <= 6) return `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3)}`

    const formattedNumber = `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3, 6)}-${numbersOnly.slice(6, maxLength)}`

    if (phone.includes('x')) {
      let extension = phone.split('x')[1] || ''
      extension = extension.slice(0, 4)
      return `${formattedNumber} x${extension}`
    }

    return formattedNumber
  }

  const phoneInput = next.container.querySelector('input[type="tel"]')

  if (phoneInput) {
    phoneInput.addEventListener('input', (e) => {
      const currentValue = e.target.value
      const numbersOnly = currentValue.replace(/[^\d]/g, '')

      if (numbersOnly.length < 10 && currentValue.includes('x')) {
        phoneInput.value = currentValue.replace('x', '')
      } else {
        phoneInput.value = formatPhone(currentValue)
      }
    })
  }
}


// quizzes
const setupQuizDialog = () => {
  const dialog = document.querySelector('dialog.quiz')
  const openDialogBtns = document.querySelectorAll('[data-dialog-btn="open"]')
  const closeDialogBtn = dialog.querySelector('[data-dialog-btn="close"]')

  openDialogBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      document.documentElement.setAttribute('data-noscroll', '')
      dialog.showModal()
      dialog.removeAttribute('inert')
    })
  })

  const closeDialog = () => {
    dialog.setAttribute('closing', '')
    dialog.setAttribute('inert', '')

    dialog.addEventListener('transitionend', () => {
      dialog.close()
      dialog.removeAttribute('closing')
      document.documentElement.removeAttribute('data-noscroll')
    }, { once: true })
  }

  closeDialogBtn.addEventListener('click', closeDialog)

  document.querySelectorAll('.btn--quiz').forEach(btn => {
    btn.addEventListener('click', closeDialog)
  })

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog()
  })

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault()
    closeDialog()
  })
}

const startQuizPopupTimer = (next) => {
  if (next.namespace === 'quiz') {
    localStorage.setItem('quizLastShown', Date.now().toString())
    return
  }

  const cooldown = 7 * 24 * 60 * 60 * 1000
  const lastShown = localStorage.getItem('quizLastShown')
  const canShow = !lastShown || (Date.now() - parseInt(lastShown, 10) > cooldown)
  if (!canShow) return

  if (sessionStorage.getItem('quizScheduled') === 'true') return
  sessionStorage.setItem('quizScheduled', 'true')

  setTimeout(() => {
    const dialog = document.querySelector('dialog.quiz')
    if (!dialog) return
    document.documentElement.setAttribute('data-noscroll', '')
    dialog.showModal()
    dialog.removeAttribute('inert')
    localStorage.setItem('quizLastShown', Date.now().toString())
  }, 30000)
}

const initQuiz = (next) => {
  const quizContainer = next.container.querySelector('.quiz__form')
  const steps = quizContainer.querySelectorAll('.form__step')
  let currentStepIndex = 0
  let currentStep = steps[currentStepIndex]
  const totalSteps = steps.length

  // show specific step
  const showStep = (index) => {
    currentStepIndex = index
    currentStep = steps[currentStepIndex]

    steps.forEach((step, i) => {
      if (i === index) {
        step.setAttribute('data-active', '')
      } else {
        step.removeAttribute('data-active')
      }
    })

    updateTabIndexes()
    updateProgressIndicator(index, totalSteps)
    updateContinueBtn()

    requestAnimationFrame(() => {
      currentStep.querySelector('a, button, input')?.focus()
    })

    // if final step, initialize input states
    if (currentStepIndex === totalSteps - 1) {
      updateInputStates()
    }

    addInputKeydownListeners()
  }

  // update tabindex and disabled state
  const updateTabIndexes = () => {
    steps.forEach((step, index) => {
      const inputs = step.querySelectorAll('input, button')

      if (index === currentStepIndex) {
        inputs.forEach((input) => {
          input.tabIndex = 0
        })
      } else {
        inputs.forEach((input) => {
          if (input.closest('.custom-input')) {
            if (input.value.trim() === '') {
              input.tabIndex = -1
              input.disabled = true
            } else {
              input.tabIndex = -1
              input.disabled = false
            }
          } else {
            input.tabIndex = -1
            input.disabled = false
          }
        })
      }
    })
  }

  // clear and uncheck step
  const clearAndUncheckStep = (step) => {
    const inputs = step.querySelectorAll('input')

    inputs.forEach((input) => {
      if (input.type === 'submit') {
        input.disabled = true
      } else if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false


        const event = new Event('change', { bubbles: true })
        input.dispatchEvent(event)
      } else {
        input.value = ''

      }

      if (input.closest('.input--quiz-custom')) {

        input.value = ''
      }
    })
  }

  // move to next step
  const nextStep = () => {
    if (currentStepIndex < steps.length - 1) {
      showStep(currentStepIndex + 1)
    }
  }

  // move to previous step
  const prevStep = () => {
    if (currentStepIndex > 0) {
      clearAndUncheckStep(steps[currentStepIndex])
      clearAndUncheckStep(steps[currentStepIndex - 1])
      showStep(currentStepIndex - 1)
    }
  }

  // add keydown events
  const addInputKeydownListeners = () => {
    const inputs = currentStep.querySelectorAll('input[type="radio"], input[type="checkbox"]')

    inputs.forEach((input) => {
      input.removeEventListener('keydown', handleInputKeydown)
      input.addEventListener('keydown', handleInputKeydown)
    })
  }

  // keydown events
  const handleInputKeydown = (event) => {
    const target = event.target

    if (target.type === 'radio') {
      const name = target.name
      const radioButtons = Array.from(currentStep.querySelectorAll(`input[type="radio"][name="${name}"]`))
      const index = radioButtons.indexOf(target)

      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) {
        event.preventDefault()
        const prevIndex = (index - 1 + radioButtons.length) % radioButtons.length
        radioButtons[prevIndex].focus()
      } else if (['ArrowRight', 'ArrowDown'].includes(event.key)) {
        event.preventDefault()
        const nextIndex = (index + 1) % radioButtons.length
        radioButtons[nextIndex].focus()
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault()
        target.checked = true
        const changeEvent = new Event('change', { bubbles: true })
        target.dispatchEvent(changeEvent)
      } else if (event.key === 'Tab') {
        if (!event.shiftKey && index < radioButtons.length - 1) {
          event.preventDefault()
          const nextIndex = index + 1
          radioButtons[nextIndex].focus()
        } else if (event.shiftKey && index > 0) {
          event.preventDefault()
          const prevIndex = index - 1
          radioButtons[prevIndex].focus()
        } else if (!event.shiftKey && index === radioButtons.length - 1) {
          return
        } else if (event.shiftKey && index === 0) {
          return
        }
      }
    }

    // checkboxes
    else if (target.type === 'checkbox') {
      const checkboxes = Array.from(currentStep.querySelectorAll('input[type="checkbox"]'))
      const index = checkboxes.indexOf(target)

      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) {
        event.preventDefault()
        const prevIndex = (index - 1 + checkboxes.length) % checkboxes.length
        checkboxes[prevIndex].focus()
      } else if (['ArrowRight', 'ArrowDown'].includes(event.key)) {
        event.preventDefault()
        const nextIndex = (index + 1) % checkboxes.length
        checkboxes[nextIndex].focus()
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        target.checked = !target.checked

        const changeEvent = new Event('change', { bubbles: true })
        target.dispatchEvent(changeEvent)
      }
    }
  }

  // back button logic
  const btnBack = quizContainer.querySelector('.btn--back')

  btnBack.addEventListener('click', prevStep)
  btnBack.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      prevStep()
    }
  })

  // progress indicator
  const updateProgressIndicator = (currentStepIndex, totalSteps) => {
    const totalStates = totalSteps - 1
    const clippedPercentage = 100 - (currentStepIndex * (100 / totalStates))
    quizContainer.querySelector('.progress-pgn').style.setProperty('--quiz-pgn', `${clippedPercentage}%`)
  }

  // update continue button state
  const updateContinueBtn = () => {
    const checkboxes = currentStep.querySelectorAll('input[type="checkbox"], input[type="radio"]')
    const customInputs = currentStep.querySelectorAll('.input--quiz-custom .input')

    const isAnyCheckboxChecked = Array.from(checkboxes).some((checkbox) => checkbox.checked)

    const isCustomBtnChecked = Array.from(customInputs).some((input) => {
      const parentBtn = input.closest('.input--quiz-custom')?.querySelector('input')
      return parentBtn?.checked
    })

    const allCustomInputsFilled = Array.from(customInputs).every((input) => {
      const parentBtn = input.closest('.input--quiz-custom')?.querySelector('input')
      return !parentBtn?.checked || (parentBtn.checked && input.value.trim() !== '')
    })

    const btnContinue = currentStep.querySelector('.btn--continue')
    if (btnContinue) {
      if (isCustomBtnChecked && !allCustomInputsFilled) {
        btnContinue.disabled = true
      } else {
        btnContinue.disabled = !(isAnyCheckboxChecked && allCustomInputsFilled)
      }
    }
  }


  // update input disabled states on final step
  const updateInputStates = () => {
    const emailPreference = document.getElementById('email-preference')
    const textPreference = document.getElementById('text-preference')
    const nameInput = document.getElementById('name')
    const emailInput = document.getElementById('email')
    const phoneInput = document.getElementById('phone')

    const isEmailSelected = emailPreference.checked
    const isTextSelected = textPreference.checked

    emailInput.disabled = !isEmailSelected
    phoneInput.disabled = !isTextSelected

    const shouldEnableName = isEmailSelected || isTextSelected
    nameInput.disabled = !shouldEnableName
  }


  // checkbox/radio change event delegation
  quizContainer.addEventListener('change', (event) => {
    const target = event.target

    // handle custom buttons with input fields
    if (target.matches('.input--quiz-custom input[type="radio"], .input--quiz-custom input[type="checkbox"]')) {
      const quizOptionContainer = target.closest('.input--quiz-custom')
      const customInputField = quizOptionContainer.querySelector('.input')
      if (target.checked) {
        if (customInputField) {
          customInputField.disabled = false
          setTimeout(() => {
            customInputField.focus()
          }, 0)
        }
      } else {
        if (customInputField) {
          customInputField.value = ''
          customInputField.disabled = true
        }
      }
      updateContinueBtn()
    }

    // handle regular radio buttons for auto skip
    else if (target.matches('.quiz-options input[type="radio"]:not(#email-preference):not(#text-preference):not(.input--quiz-custom input[type="radio"])')) {
      if (target.checked) {
        setTimeout(nextStep, 400)
      }
    }

    // regular checkboxes
    else if (target.matches('.quiz-options input[type="checkbox"]:not(.input--quiz-custom input[type="checkbox"])')) {
      updateContinueBtn()
    }

    // handle final step radio buttons
    else if (target.matches('#email-preference, #text-preference')) {
      updateInputStates()
    }
  })

  // input events
  quizContainer.addEventListener('input', (event) => {
    const target = event.target

    if (target.matches('.input--quiz-custom .input')) {
      updateContinueBtn()
    }
  })

  // continue button logic using event delegation
  quizContainer.addEventListener('click', (event) => {
    const btnContinue = event.target.closest('.btn--continue')

    if (btnContinue && quizContainer.contains(btnContinue)) {
      event.preventDefault()
      nextStep()
    }
  })

  showStep(currentStepIndex)
}


// promo bar
const setupPromoBar = () => {
  const promoBar = document.querySelector('.promo-bar')

  const layoutEls = () => document.querySelectorAll(
    '.header__brand, .header__nav, .header__touch, main, .hero, .hero--alt, .inventory, .gallery, .f-carousel__viewport, .f-spinner-wrap'
  )

  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${value};expires=${expires};path=/`
  }

  const getCookie = (name) =>
    document.cookie.split('; ').find((row) => row.startsWith(name + '='))?.split('=')[1]

  const setPromoHeight = (height) => {
    const px = `${height}px`
    document.documentElement.style.setProperty('--promo--height', px)
    document.documentElement.style.setProperty('--promo--offset', px)
  }

  const syncPromoHeight = () => {
    setPromoHeight(promoBar.hasAttribute('tuck') ? 0 : promoBar.offsetHeight)
  }

  const hidePromoInstantly = () => {
    const els = layoutEls()
    els.forEach((el) => { el.style.transition = 'none' })
    promoBar.setAttribute('tuck', '')
    setPromoHeight(0)
    promoBar.style.display = 'none'
    void promoBar.offsetHeight
    els.forEach((el) => { el.style.transition = '' })
  }

  if (getCookie('promoHidden')) {
    hidePromoInstantly()
    return
  }

  syncPromoHeight()

  let resizeTimeout
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(syncPromoHeight, 150)
  })

  promoBar.querySelector('.btn--close-alt').addEventListener('click', () => {
    promoBar.setAttribute('tuck', '')
    document.documentElement.style.setProperty('--promo--offset', '0px')
    setCookie('promoHidden', 'true', 7)

    promoBar.addEventListener('transitionend', () => {
      setPromoHeight(0)
      promoBar.style.display = 'none'
    }, { once: true })
  })
}


// credit
console.log('%cDesign & Dev by Johnny Zimmer — https://johnnyzimmer.com', 'background-color: #000; color: #fff; font-size:10px; padding:8px 10px 6px; border-radius:4px')